package org.example.project.ui

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.game.MultiplayerLobbyViewModel

/**
 * LobbyScreen — nur fuer Gast (Code eingeben).
 * Host springt direkt SETUP -> GAME, sieht den Code dort.
 */
@Composable
fun LobbyScreen(
    playerName: String,
    playerAvatarName: String,
    langCode: String,
    difficulty: String,
    onBack: () -> Unit,
    onRoomJoined: (roomCode: String) -> Unit
) {
    val vm = remember(playerName, playerAvatarName, langCode, difficulty) {
        MultiplayerLobbyViewModel(
            playerName = playerName,
            playerAvatar = playerAvatarName,
            langCode = langCode,
            difficulty = difficulty
        )
    }
    val isLoading by vm.isLoading.collectAsState()
    val errorMessage by vm.errorMessage.collectAsState()
    val navigateToGame by vm.navigateToGame.collectAsState()
    val currentRoomCode by vm.currentRoomCode.collectAsState()

    var roomCodeInput by remember { mutableStateOf("") }

    LaunchedEffect(navigateToGame) {
        if (navigateToGame && currentRoomCode != null) {
            vm.onGameStarted()
            onRoomJoined(currentRoomCode!!)
        }
    }

    DisposableEffect(Unit) { onDispose { vm.dispose() } }

    val deepBlue = Color(0xFF0D47A1)
    val gold = Color(0xFFFFD700)
    val navyBlue = Color(0xFF071F4A)

    Box(modifier = Modifier.fillMaxSize().background(deepBlue)) {
        Icon(
            Icons.AutoMirrored.Filled.ArrowBack, null, tint = gold,
            modifier = Modifier.padding(16.dp).size(30.dp).clickable { onBack() }
        )

        Column(
            modifier = Modifier.fillMaxSize().padding(horizontal = 40.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Text("RAUM BEITRETEN", color = gold, fontSize = 24.sp, fontWeight = FontWeight.Black)
            Spacer(modifier = Modifier.height(40.dp))

            if (isLoading) {
                CircularProgressIndicator(color = gold)
                Text("Bitte warten...", color = Color.White, modifier = Modifier.padding(top = 16.dp))
            }

            errorMessage?.let {
                Text(it, color = Color.Red, fontWeight = FontWeight.Bold, modifier = Modifier.padding(8.dp))
            }

            BasicTextField(
                value = roomCodeInput,
                onValueChange = {
                    if (it.length <= 6 && it.all { c -> c.isDigit() }) roomCodeInput = it
                },
                textStyle = TextStyle(
                    color = navyBlue, fontSize = 24.sp,
                    textAlign = TextAlign.Center, fontWeight = FontWeight.Bold,
                    letterSpacing = 6.sp
                ),
                decorationBox = { inner ->
                    Box(
                        modifier = Modifier.fillMaxWidth().height(70.dp)
                            .background(Color.White, RoundedCornerShape(12.dp)),
                        contentAlignment = Alignment.Center
                    ) {
                        if (roomCodeInput.isEmpty()) {
                            Text("Code eingeben", color = Color.Gray, fontSize = 18.sp)
                        }
                        inner()
                    }
                }
            )

            Spacer(modifier = Modifier.height(24.dp))

            Button(
                onClick = {
                    if (roomCodeInput.length == 6) {
                        vm.joinRoom(roomCodeInput)
                    }
                },
                modifier = Modifier.fillMaxWidth().height(60.dp),
                shape = RoundedCornerShape(30.dp),
                colors = ButtonDefaults.buttonColors(containerColor = gold)
            ) {
                Text("BEITRETEN", color = navyBlue,
                    fontWeight = FontWeight.Bold, fontSize = 18.sp)
            }
        }
    }
}